import type { SVGProps } from 'react'
const SvgCalendarMonth = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="calendar-month_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#calendar-month_svg__a)">
      <path d="M3.804 16.653q-.708 0-1.208-.5a1.65 1.65 0 0 1-.498-1.207V4.554q0-.708.498-1.208a1.65 1.65 0 0 1 1.208-.498H4.5v-1.5h1.603v1.5h5.794v-1.5H13.5v1.5h.696q.71 0 1.207.498.5.5.5 1.208v10.392q0 .709-.5 1.208a1.64 1.64 0 0 1-1.207.498zm0-1.707h10.392V7.5H3.804zm0-8.946h10.392V4.554H3.804zM9 10.536a.76.76 0 0 1-.56-.226.76.76 0 0 1-.226-.56.76.76 0 0 1 .226-.56.76.76 0 0 1 .56-.226.76.76 0 0 1 .56.226.76.76 0 0 1 .226.56.76.76 0 0 1-.226.56.76.76 0 0 1-.56.226m-3 0a.76.76 0 0 1-.56-.226.76.76 0 0 1-.226-.56.76.76 0 0 1 .226-.56.76.76 0 0 1 .56-.226.76.76 0 0 1 .56.226.76.76 0 0 1 .226.56.76.76 0 0 1-.226.56.76.76 0 0 1-.56.226m6 0a.76.76 0 0 1-.557-.226.76.76 0 0 1-.229-.56q0-.335.23-.56a.77.77 0 0 1 .558-.226q.33 0 .557.226.227.225.227.56a.76.76 0 0 1-.226.56.76.76 0 0 1-.56.226m-3 3a.76.76 0 0 1-.56-.23.77.77 0 0 1-.226-.558q0-.33.226-.557a.76.76 0 0 1 .56-.227.76.76 0 0 1 .56.226.76.76 0 0 1 .226.56.76.76 0 0 1-.226.557.76.76 0 0 1-.56.229m-3 0a.76.76 0 0 1-.56-.23.77.77 0 0 1-.226-.558q0-.33.226-.557a.76.76 0 0 1 .56-.227.76.76 0 0 1 .56.226.76.76 0 0 1 .226.56.76.76 0 0 1-.226.557.76.76 0 0 1-.56.229m6 0a.76.76 0 0 1-.557-.23.76.76 0 0 1-.229-.558q0-.33.23-.557a.77.77 0 0 1 .558-.227q.33 0 .557.226.227.225.227.56a.76.76 0 0 1-.226.557.76.76 0 0 1-.56.229" />
    </g>
  </svg>
)
export default SvgCalendarMonth
